<template>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'ATLoader'
}
</script>

<style lang="scss">
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  margin-left: calc(50% - 40px);
  margin-top: 50px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 50px;
  height: 50px;
  margin: 6px;
  border: 6px solid #77b017;
  border-radius: 50%;
  animation: lds-ring 0.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #77b017 transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: 0.05s;
}

.lds-ring div:nth-child(2) {
  animation-delay: 0.1s;
}

.lds-ring div:nth-child(3) {
  animation-delay: 0s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>